<lib-single-select-search
  [options]="cityOptions"
  [control]="control"
  [placeholder]="placeholder"
  [myFloatLabel]="'never'"
  [setControlValue]="true"
  [forceControl]="true"
  [ngClass]="{ 'error-field': hasError }"
  (valueChanged)="onSearchChanged($event)"
  (changed)="onCitySelected($event)"
></lib-single-select-search>
